<template>
  <StatusPill
    :text="displayText"
    :backgroundColor="backgroundColor"
    :isProcessing="isProcessing"
  />
</template>

<script>
import StatusPill from "./StatusPill.vue";
import { getScanStatusConfig } from "@/utils/ScanStatus";
import { Permissions } from "@/constants/permissions";
import { usePermissions } from "@/composable/usePermissions";

export default {
  name: "ScanStatusPill",
  components: {
    StatusPill
  },
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  setup() {
    // Admin-aware from the inside: every pill in the app automatically shows
    // Duallo staff the true status (e.g. "Waiting for Duallo Review") while
    // customers see the safe presentation ("AI Analysis In Progress") — no
    // per-callsite flag to forget, no way to leak the review state.
    const { can } = usePermissions();
    return { can };
  },
  computed: {
    config() {
      return getScanStatusConfig(this.status, this.can(Permissions.DualloAdminView));
    },
    displayText() {
      return this.config.text;
    },
    backgroundColor() {
      return this.config.color;
    },
    isProcessing() {
      return this.config.processing;
    }
  }
};
</script>
